<div class="page-container" [class.loading]="!menuService.areDependenciesLoaded">
    <app-header [title]="title ?? ''" [menuService]="menuService" />
    <router-outlet></router-outlet>
</div>
